import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from './LoginForm';

const Login: React.FC = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate('/dashboard');
    };

    return (
        <div style={{
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            background: '#f5f5f5',
            minHeight: '100vh',
            padding: '40px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <div style={{
                background: 'white',
                borderRadius: '24px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                border: '3px solid #6C5CE7',
                width: '100%',
                maxWidth: '500px'
            }}>
                <LoginForm 
                    variant="page"
                    onSuccess={handleSuccess}
                />
            </div>
        </div>
    );
};

export default Login;